import React, { useState, useContext } from 'react';
import DashboardContext from '../../Contexts/DashboardContext';
import Paper from '@material-ui/core/Paper';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';
import DashboardIcon from '@material-ui/icons/Dashboard';
import ShoppingCartIcon from '@material-ui/icons/ShoppingCart';
import PeopleIcon from '@material-ui/icons/People';
import BarChartIcon from '@material-ui/icons/BarChart';
import LayersIcon from '@material-ui/icons/Layers';
import AssignmentIcon from '@material-ui/icons/Assignment';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import GavelIcon from '@material-ui/icons/Gavel';
import HourglassFullIcon from '@material-ui/icons/HourglassFull';
import AuctionsTable from '../Table/AuctionsTable';
import CreateAuction from '../../Auction/FormControl/CreateAuction';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
    hover: {
        '&:hover': {
            background: '#15616d',
        }
    },

    listItemText: {
        color: '#ffecd1',
    },

    disabledButton: {
        textTransform: 'capitalize',
        color: 'grey',
        '&:hover': {
            cursor: 'default',
        },
        '&:focus':{
            outline: 'none'
        }
    },
    paper: {
        padding: theme.spacing(2),
        display: 'flex',
        overflow: 'auto',
        flexDirection: 'column',
    },
}));

const MainListItems = () => {
    const classes = useStyles();
    // Deconstruct needed context parameters 
    const { setDisplayAuctionsTable } = useContext(DashboardContext);
    
    return (
        <>
            <div>
                <ListItem button className={classes.disabledButton}>
                    <ListItemIcon>
                        <DashboardIcon style={{color: 'grey'}}/>
                    </ListItemIcon>
                    <ListItemText primary="Dashboard" />
                </ListItem>
            </div>
            
            <div>
                <ListItem button className={classes.disabledButton}>
                    <ListItemIcon>
                        <AccountCircleIcon style={{color: 'grey'}}/>
                    </ListItemIcon>
                    <ListItemText primary="Profile"/>
                </ListItem>
            </div>

            <div className={classes.hover} >
                <ListItem button>
                    <ListItemIcon>
                        <HourglassFullIcon style={{color: '#ffecd1'}}/>
                    </ListItemIcon>
                    <ListItemText className={classes.listItemText} onClick={() => setDisplayAuctionsTable( <Paper className={classes.paper}><AuctionsTable/></Paper>)} primary="Auctions" />
                </ListItem>
            </div>

            <div className={classes.hover}>
                <ListItem button style={{paddingTop: '2px', paddingBottom: '2px'}}>
                        <ListItemIcon >
                        </ListItemIcon>
                        <ListItemText 
                        primaryTypographyProps = {{
                            variant: 'body2',
                        }}
                        className={classes.listItemText} primary="Create auction" 
                        onClick={() => setDisplayAuctionsTable( <Paper className={classes.paper}><CreateAuction/></Paper>)}
                        />
                </ListItem>
            </div>

            <div className={classes.hover}>
                <ListItem button style={{paddingTop: '2px', paddingBottom: '2px'}}>
                        <ListItemIcon >
                        </ListItemIcon>
                        <ListItemText 
                        primaryTypographyProps = {{
                            variant: 'body2',
                        }}
                        className={classes.listItemText} primary="Search auction" />
                </ListItem>
            </div>

            <div>
                <ListItem button style={{paddingTop: '0px', paddingBottom: '2px'}} className={classes.disabledButton}>
                        <ListItemIcon >
                        </ListItemIcon>
                        <ListItemText 
                        primaryTypographyProps = {{
                            variant: 'body2',
                        }}
                        primary="Won auction" />
                </ListItem>
            </div>
            
            <div>
                <ListItem button className={classes.disabledButton} style={{paddingTop: '0px', paddingBottom: '2px'}}>
                    <ListItemIcon>
                        <GavelIcon style={{color: 'grey'}}/>
                    </ListItemIcon>
                    <ListItemText primary="Bids" />
                </ListItem>
            </div>
            
            {/* <div className={classes.hover}>
                <ListItem button>
                    <ListItemIcon>
                        <LayersIcon style={{color: '#ffecd1'}}/>
                    </ListItemIcon>
                    <ListItemText className={classes.listItemText}  primary="Integrations" />
                </ListItem>
            </div> */}
            
        </>
        )
    
};

export default MainListItems;